module.exports = __webpack_public_path__ + "img/list-doc.6dd41355.svg";